<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>

        <v-row justify="center">

          <v-col cols="12" lg="8" md="8" sm="12">

          <v-card color="#393E46">
              <v-card-title>
                Foto de Perfil
              </v-card-title>
              <v-card-text>
                <v-alert
                    :value="alerteditar"
                    color="green"
                    dark
                    dismissible
                    border="top"
                    transition="scale-transition"
                >
                  Se Foto de Perfil fue editada con Exito
                </v-alert>
                <v-dialog v-model="dialogimage"  max-width="600">
                  <v-card>
                    <v-card-title class="headline">Zoom</v-card-title>

                    <v-img :src="imagen2"  />

                  </v-card>
                </v-dialog>
                <v-row>
                  <v-col v-if="hayimagen" md="12" lg="12" cols="12">

                    <v-img :src="imagen2" @click="zoomImage" height="300px" aspect-ratio="1.7" />
                  </v-col>
                  <v-col md="12" lg="12" cols="12">
                    <v-file-input
                        label="Subir Archivo"
                        accept="image/*"
                        filled
                        chips
                        v-model="imagen"
                        @change="onFileChange"
                        prepend-icon="mdi-camera"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col>
                    <v-btn color="red">
                      <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'password'}">Cambiar Password</router-link>
                    </v-btn>
                  </v-col>
                <v-col>
                  <v-btn color="green">
                    <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'perfil'}">Datos</router-link>
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn color="brown">
                    <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'direccion'}">Direccion</router-link>
                  </v-btn>
                </v-col></v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import axios from 'axios';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'fotoperfil',
  title: 'Foto de Perfil | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
  },
  data: () => ({
    paises: {},
    overlay:false,
    token:'',
    date: new Date().toISOString().substr(0, 10),
    provincias:[],
    alerteditar: false,
    ciudades:[],
    distritos:[],
    dialogimage:false,
    elcolor:'',
    imagen:'',
    imagen2:'',
    hayimagen:false,
    tiposdocumento: [],
    password:'',
    cpassword: '',
    getips:'',
    menu1:false,
  }),
  mounted() {
    this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

    if(this.usuario.foto ==="" || this.usuario.foto  === null){
      this.hayimagen = false

    }else{
      this.imagen2 = URL.createObjectURL(this.usuario.foto)
      this.hayimagen = true
    }

  },
  methods:{
    getPaises(){
      axios.get("paises/activos",{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.paises = response.data
          })
    },
    zoomImage(){
      this.dialogimage = true
    },
    onFileChange(e) {
      this.imagen2= URL.createObjectURL(this.imagen)
      this.hayimagen = true
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen);
      let url = "personas/foto/" + this.usuario.id
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.alerteditar = true
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
      console.log(e)
    },


  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>